import LoadingButton from '../../buttons/LoadingButton';
import TextInputArea from '../../inputs/TextInputArea';

const SUPage8 = ({
	wrapperStyle,
	headerStyle,
	AdditionalInputWrapperStyle,
	SetState,
	AdditionalButtonStyle,
	IsLoading,
	OnClick,
	OnInputChange,
	InputValue,
}) => {
	return (
		<div className={wrapperStyle}>
			<>
				<div className={headerStyle}>Tell us about yourself</div>
				<TextInputArea
					Placeholder={'Enter your bio'}
					SetState={SetState}
					AdditionalWrapperStyle={AdditionalInputWrapperStyle}
					OnInputChange={OnInputChange}
					Value={InputValue}
				/>
			</>
			<LoadingButton
				IsLoading={IsLoading}
				OnClick={OnClick}
				Message="Continue"
				IsSecondary={false}
				AdditionalButtonStyle={AdditionalButtonStyle}
			/>
		</div>
	);
};

export default SUPage8;
